import { Link } from "react-router-dom";

const quickLinks = [
  { to: "/", label: "首页" },
  { to: "/category", label: "影视分类" },
  { to: "/news", label: "新闻资讯" },
  { to: "/special", label: "专题合集" },
  { to: "/search", label: "搜索" },
];

const categories = [
  { to: "/category?type=电影", label: "百合电影" },
  { to: "/category?type=电视剧", label: "百合电视剧" },
  { to: "/category?sort=rating", label: "高分推荐" },
  { to: "/category?sort=latest", label: "最新上线" },
];

export default function Footer() {
  return (
    <footer className="mt-20 border-t border-primary-100 bg-primary-50">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50 text-lg">
                <i className="ri-flower-fill" />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">
                百合影视
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              专注百合题材影视内容，提供丰富的电影、电视剧资讯与详细剧情介绍，帮助每一位爱好者找到心动的作品。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950">
              快速导航
            </h4>
            <ul className="mt-4 space-y-2.5">
              {quickLinks.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950">
              热门分类
            </h4>
            <ul className="mt-4 space-y-2.5">
              {categories.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950">
              联系我们
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-mail-line" />
                </span>
                hello@lilium-cinema.demo
              </li>
              <li className="flex items-center gap-2">
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-wechat-line" />
                </span>
                微信公众号：百合影视
              </li>
              <li className="flex items-center gap-2">
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-map-pin-line" />
                </span>
                本站为演示站点
              </li>
            </ul>
            <div className="mt-4 flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-500">
                <i className="ri-weibo-line" />
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-500">
                <i className="ri-bilibili-line" />
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-500">
                <i className="ri-instagram-line" />
              </span>
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-primary-100 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2024 百合影视 Lilium Cinema · 本站内容均为虚构演示数据</p>
          <p>仅供学习与演示使用，未接入真实播放与会员服务</p>
        </div>
      </div>
    </footer>
  );
}